/* =========================================
SCRIPT FOR THE ORDER/TABLE BEHAVIOR
============================================*/
const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiNDk3Njk3MThhYzJjMTcxMjRiYjUyYzk4NmUxN2M2M2IyZDgyN2M1YzQwNTUwZGM4OWU4ZDFlOGJkZDg1YmYyNmUyMGQ2OWNjNGIzNGE5MGMiLCJpYXQiOjE3MzEzMTg1NzQsIm5iZiI6MTczMTMxODU3NCwiZXhwIjoxNzYyODU0NTc0LCJzdWIiOiIzIiwic2NvcGVzIjpbXX0.ib9QblHmL79jNcBov2nsQPv3n9_sED0TNGkyTrZ1Lu1hjsX13VDhlnXxLuQa9xigWkvV_LlAa8Cx1i3JmalZX9DwAzGDg69soSOEt7uAfAYFJO_T5k2z2EpyfI_SIjiT_Xfgi368CoKL5Ev-884G9bvRNNfhqRcsQq0OR0u6zpjlZ4BRi2w0BaOY9KYodC2_v4WWrOMJGEFVlbNYzslzcAUytnpBF4rfABFVJA_qPUsA45IsjKjXBxWii8eIPRDLObr4sOaptBkqwP5IABS1n2ROr5Pt6VcbRlDTkZkXw9GjhSMde4wl_UvyZ0kiMtV4Jf8DpM3HA5ckyzuBA6PlYj5Y5npzMWDWgj54OfoI-T3f4j3aLYAnfqB_beQ3LT4V045QzRitB0Mx7I1AQRu_Dsh6YaE0rhoSFRm_7G-Nl9kR25EhACX_Zp6vs2yS-tT8nOOwYaXd6ndGP6_9WNYx2rFo_6hxufT96f2xesYqfzuqnB7fGXPBkGSe2J2YlZtg3feFxdCcxPYCOppxJqy7jQ3zjvWmehbuPvOMUF9pFa0Ep4pW76EOBmb_DzVM2BzEd5Re_518d6_3PUyVe0u_PoZI3cDvDWrckKGPkqNjbwbYAIUPMFruNU3cpk0-c4_D2SA9h0zPtpmF8vZwLcyNyih742ncLMXzAZsD7xtFP5E";
//veera local
//const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiN2FlMTI0YjI3Njg2YWYzYzZlM2NiZjZmMGI0ZTBkODFlZWM2Y2VmMjVkMTFlZmVkNDA0OTdkMmI5MzcwNTFhNDE0MDZjYzY3YzMwY2I4MDIiLCJpYXQiOjE2OTQ3NDM1MTEsIm5iZiI6MTY5NDc0MzUxMSwiZXhwIjoxNzI2MzY1OTExLCJzdWIiOiI1Iiwic2NvcGVzIjpbXX0.fvWOzRQwlQxAcOo50_9fCCKFR9c3FLNiThNOAtiQp42TJB7SyQs5SiRSjtBChBBcbr90bn0A0JoWwhjj4yZ4hYpXkTuwYXNDpKVKGkaqodPlkvQZdEjy2Rq0RzCa6IYjngBACmeLgZaTBNJ153niCg_Mw8Zvh9RMK_DhRhqYwItDsaDNpN_0J3aSOTNXbiE6ZIbFbnyARS90QUn2auwj8Mn5ropsC7N3SuI0rlQWUV3C8SAxB9OZ0i9nwPDbnHVCROehRAD0lJ6YUd5RLi-Br4s-56dN57EwOIBdhQQ1OBm-UuAja1tPjX7ak9s5f24vJ01N8m2R1DbJ7NfiwzGUOEca5TEpZN1lSRGTLdke9uc9jGRCuCWodKl6C1gp08gzPBLF5gSKZoI_-42MXJVQjlRYoiNe6JqQu678o6weI5BtjPYOo45Tt84CiBYhdw0sBjUqXVbZOx-nEoOYquLczKaUVFHSeDi19X6DQKRS2hFUqluPiTr9MhtcZYydHk94eNIJ1iXCk40qbPeRtt5N1r0158kDYte5e_JWyeROBwEdBewIU0TuH001hT2PStlhlx6ipZOp0gZ3-cMJXlv32izpyUJgKXL5t0l7b3Ll4TkJENCHT55h2i0alfIas71_7h_ovaHPXXUksqfKd2tKIeJcWKYrNPblvkk6pT6ikdA";
//staging
//const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiODBmN2MzZTI4OGMzOTZlOGRmNjJkMTM0Y2U2NmY2NWMzMGQ1YWZhNjZlZGJlMGEyZjY2ZTA5ODZhYWU1MDEyODQwMWQyYThmY2MzOGIzZDIiLCJpYXQiOjE2OTY2MDI4MDYsIm5iZiI6MTY5NjYwMjgwNiwiZXhwIjoxNzI4MjI1MjA2LCJzdWIiOiIxMiIsInNjb3BlcyI6W119.6AwER_NQTfWtaub6tSoJYeEq8WPeBul2mraPSLnnSJrNbSDQVroFq5HHyfD_WrH34E33SZpb_5U3_I4zaqxULA0dyqjywVBM8LqgU2z_A11djRm7_0cp_CpuU4-9B_Xvn1BHBF3Rb7GBlBa7jopUkwAo9mzrdbrfwbLYXKUeHGnBBcMWPJ_62g7KrIWeBg2hUnwPY3Eyh4OPLxxgixzi1Qzd0xeXfQ6PyMTMBKLPBkxDPbWXntNQ0bmmZOTbyxwVv9UCLOc6DQH3KcYhOXMXBBbljaryKe9ePX09Sa-FjTNKxLwaUhYyOcNZNhLSxa8hyN6nWeAlbLYXCZ8mvrlhNOJUrqxf-Ecth6nxZDpTUk3C0DYhGIUqUVfgsJwRZ82exCkZ4CfNglPU5SJZ5kW51k4Y3TV915M0twhIAf4N33vVLg0KK5YxEDq_hHDusDUy1jvQFC1MjL9c64bV3059o4K_6T8SiFPhJ0dBBtVhwRySzO0XT0YmZEZ2zeorU-LWJrlM1QlmUAnabRjxYohbBx1MgXOVOfzPEFZRa4mL8O83eYd6Ox2_d_OAJhRqPNrr8SaWpeUc9XBRPhLGu4xAhnlkigZgL3gv8mvNRvUyCa3xigiGhSLu6wgj7bdS2InpTAYIMcMn--LQTW1alDJYvkoNugU8jlTYkAe6X2UmhNg";

var email, phone, otp, otp_hash, pay_type, total_sum, upfront_years;
var aircon_url = "https://jobmaster.prismplushome.sg";
//var aircon_url = "https://stg-jobmaster.prismplushome.sg";
//var aircon_url = "https://e8d6-103-98-209-98.ngrok-free.app";
var button = document.querySelector("#submit-button");
var timeleft = 90;
var extra_unit_price = 22;
var upfront_discount = 10;
var allowed_units = 16;
var utm_params = getUTMParams();
var ua_details = getUADetails();
var retail = reatilParams();
var payment_token = null;
var deviceData = null;
console.log("prismcarev5");
console.log(
  "uadetails:" +
    ua_details.userAgent +
    " - " +
    ua_details.deviceType +
    " - " +
    ua_details.OS +
    " - " +
    ua_details.browser +
    " - " +
    ua_details.resolution
);
$body = jQuery("body");

jQuery(".system_qty-input").change(function () {
  //set value of total of all rows
  hideError();
  total_sum = price_calculation();
  $("#total_price").text("$" + total_sum);
});
pay_type_update();
jQuery("input[name='pay_type']").click(function () {
  pay_type_update();
  if ($(this).val() == "upfront") {
    $("#upfront_years").addClass("active");
  } else {
    $("#upfront_years").removeClass("active");
  }
});

jQuery("#upfront_years").change(function () {
  pay_type_update();
});

jQuery(".qty-increase").click(function () {
  var system = $(this).attr("data-system");
  cObj = $("#sys" + system + "-qty");
  var sys_qty = cObj.val();
  if (parseInt(sys_qty) >= allowed_units) {
    showError(
      "Maximum of " + allowed_units + " units is allowed per subscription."
    );
    return false;
  } else {
    hideError();
  }
  cObj.val(parseInt(sys_qty) + 1);
  total_sum = price_calculation();
  cart_summary();
});
jQuery(".qty-decrease").click(function () {
  hideError();
  var system = $(this).attr("data-system");
  cObj = $("#sys" + system + "-qty");
  var sys_qty = cObj.val();
  if (parseInt(sys_qty) == 0) {
    return false;
  }
  cObj.val(parseInt(sys_qty) - 1);
  total_sum = price_calculation();
  cart_summary();
});
function pay_type_update() {
  pay_type = jQuery("input[name='pay_type']:checked").val();
  jQuery("input[name='pay_type']").parent().removeClass("active");
  jQuery("input[name='pay_type']:checked").parent().addClass("active");
  jQuery(".pay-select .select-indicator").text("Select");
  jQuery(".pay-select.active .select-indicator").text("Selected");
  total_sum = price_calculation();

  if (pay_type == "upfront") {
    upfront_years = parseInt(jQuery("#upfront_years").val());
    $(".pay-type").text(upfront_years + " years upfront");
    $(".pay-type-small").text(upfront_years + " years upfront");
    $(".yearly-disclaimer .yearly-qty").text(upfront_years);
    $(".pay-item.pay-wrap.upfront-wrap").addClass("active");
    $(".pay-option .pay-item").removeClass("active");
    $(".pay-option .pay-upfront").parent().addClass("active");
    $(".option-prices, .total-wrap .pay-today, .pay-info").removeClass(
      "active"
    );
    $(
      "#option-pay-upfront, .total-wrap .pay-today, .total-wrap .pay-info.pay-upfront"
    ).addClass("active");
    if (upfront_years != "10") {
      $(".yearly-disclaimer, .disclaimer.pay-info.pay-upfront").addClass(
        "active"
      );
    } else {
      $(".yearly-disclaimer, .pay-info.pay-upfront").removeClass("active");
    }
  } else if (pay_type == "yearly") {
    $(".pay-type").text("Yearly");
    $(".pay-type-small").text("yearly");
    $(".pay-option .pay-item").removeClass("active");
    $(".pay-option .pay-yearly").parent().addClass("active");
    $(".yearly-disclaimer").removeClass("active");
    $(".pay-item.pay-wrap.upfront-wrap").removeClass("active");
    $(".option-prices, .total-wrap .pay-today, .pay-info").removeClass(
      "active"
    );
    $("#option-pay-yearly, .pay-info.pay-yearly").addClass("active");
  } else if (pay_type == "quarterly") {
    $(".pay-type").text("Quarterly");
    $(".pay-type-small").text("quarterly");
    $(".pay-option .pay-item").removeClass("active");
    $(".pay-option .pay-qtrly").parent().addClass("active");
    $(".yearly-disclaimer").removeClass("active");
    $(".pay-item.pay-wrap.upfront-wrap").removeClass("active");
    $(".option-prices, .total-wrap .pay-today, .pay-info").removeClass(
      "active"
    );
    $("#option-pay-qty, .pay-info.pay-qtrly").addClass("active");
    
  } else {
    upfront_years = parseInt(jQuery("#upfront_years").val());
    $(".pay-type").text(upfront_years + " years upfront");
    $(".pay-type-small").text(upfront_years + " years upfront");
    $(".yearly-disclaimer .yearly-qty").text(upfront_years);
    $(".pay-option .pay-item").removeClass("active");
    $(".pay-option .pay-upfront").parent().parent().addClass("active");
    $(".option-prices, .total-wrap .pay-today, .pay-info").removeClass(
      "active"
    );
    $(
      "#option-pay-upfront, .total-wrap .pay-today, .pay-info.pay-upfront"
    ).addClass("active");
    if (upfront_years != "10") {
      $(".yearly-disclaimer").addClass("active");
    } else {
      $(".yearly-disclaimer").removeClass("active");
    }
    $(".pay-item.pay-wrap.upfront-wrap").removeClass("active");
  }

  cart_summary();
}
function price_calculation() {
  var totalunit = 0;
  var total_systems = 0;

  jQuery(".system_qty-input").each(function () {
    var sysqty = this.value;
    var sysval = jQuery(this).attr("data-price");
    totalunit += parseInt(sysqty) * parseInt(sysval);
    total_systems += parseInt(sysqty);
  });
  console.log(totalunit);
  if (totalunit > allowed_units) {
    showError(
      "Maximum of " + allowed_units + " units is allowed per subscription."
    );
    return false;
  }
  var total_sum = 0;
  if (totalunit == 1) {
    total_sum = 59;
  } else if (totalunit == 2) {
    total_sum = 69;
  } else if (totalunit == 3) {
    total_sum = 89;
  } else if (totalunit == 4) {
    total_sum = 109;
  } else if (totalunit == 5) {
    total_sum = 129;
  } else if (totalunit > 0) {
    total_sum = 159 + (totalunit - 6) * extra_unit_price;
  }
  pay_type = jQuery("input[name='pay_type']:checked").val();

  var unit = "units";
  if (totalunit <= 1) {
    unit = "unit";
  }
  if (pay_type == "upfront") {
    total_sum = total_sum - upfront_discount;
    upfront_years = parseInt(jQuery("#upfront_years").val());
    jQuery(".units").text(
      totalunit +
        " " +
        unit +
        " x " +
        upfront_years +
        " years =  $" +
        numberWithCommas(total_sum) +
        " x " +
        upfront_years * 4 +
        " quarters"
    );
    jQuery(".upfront-years-num").text(upfront_years);
    total_sum = total_sum * 4 * upfront_years;
  } else if (pay_type == "yearly") {
    total_sum = total_sum - upfront_discount;
    jQuery(".units").text(
      totalunit +
        " " +
        unit +
        " yearly =  $" +
        numberWithCommas(total_sum) +
        " x 4 quarters"
    );
    total_sum = total_sum * 4;
  } else {
    jQuery(".units").text(totalunit + " units quarterly");
  }
  if (total_sum < 0) {
    total_sum = 0;
  }
  jQuery(".total-purchase").text("$" + numberWithCommas(total_sum));

  return total_sum;
}

function cart_summary() {
  
  
  var cart_html = "";
  var cart_plan = "";
  jQuery(".system_qty-input").each(function () {
    var sysqty = this.value;
    var pay_text = "Pay " + pay_type;
    if (pay_type == "upfront") {
      /*
      var dateNow = new Date().toLocaleDateString('en-us', { month:"long", year:"numeric",  day:"numeric"});
      var oneYearFromNow = new Date();
      oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + upfront_years);
  
      
      var plan_date = oneYearFromNow.toLocaleDateString('en-us', { month:"long", year:"numeric",  day:"numeric"});
      
      pay_text =
        'Pay Upfront <br><span class="years">' +
        upfront_years +
        " Years (From " +
        dateNow +
        " - " +
        plan_date +
        ")</span>";
        */
        pay_text =
        'Pay Upfront <br><span class="years">' +
        upfront_years +
        " Years</span>";
    }
    if (parseInt(sysqty) > 0) {
      var sysval = jQuery(this).attr("data-price");

      var unit = "Units";
      if (parseInt(sysval) == 1) {
        unit = "Unit";
      }
      cart_html +=
        '<div class="system-item flex-wrap justify-between"><div class="selected-system"><p class="sys-type">' +
        sysval +
        " " +
        unit +
        " x " +
        sysqty +
        "</p></div></div>";
      cart_plan = '<h3 class="mobile-show">Plan</h3><p class="pay-type">' + pay_text + "</p>";
    }
  });
  jQuery(".cart-items").html(cart_html);
  jQuery(".cart-plan-type").html(cart_plan);
  if (retail) {
    jQuery("#staffName").val(getStaffName());
    jQuery("#staffName").show();
  } else {
    jQuery("#staffName").val(getStaffName());
    jQuery("#staffName").show();
  }
}

/* =========================================
SCRIPT FOR THE MULTISTEP FORM
============================================*/
var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab

function showTab(n) {
  console.log("j1");
  // This function will display the specified tab of the form...
  var x = document.getElementsByClassName("steps");
  x[n].style.display = "flex";
  //... and fix the Previous/Next buttons:

  //... and run a function that will display the correct step indicator:
  fixStepIndicator(n);
  
}

function showError(message) {
  let error = "<strong>Error!</strong> " + message;
  $("#error_tag").html(error);
  $("#error_tag").css("visibility", "visible");
}

function hideError() {
  $("#error_tag").html("");
  $("#error_tag").css("visibility", "hidden");
}

function showValidationError(cObj, message) {
  $(cObj).next().remove("span");
  cObj.addClass("invalid");
  cObj.after('<span class="validation error">' + message + "</span>");
}

function removeValidationError(cObj) {
  $(cObj).removeClass("invalid");
  $(cObj).next().remove("span");
}

function nextPrev(n) {
  console.log(currentTab);
  console.log("nextperv");
  // This function will figure out which tab to display
  var x = document.getElementsByClassName("steps");
  // Exit the function if any field in the current tab is invalid:
  if (n == 1 && !validateForm()) return false;
  // Hide the current tab:
  if (currentTab == 0) {
    sendusertoOTP(n, switchTab);
    // email = $("#email").val().trim();
    //phone = $("#phone").val().trim();
    //validateOTP(n+1, switchTab);
    //$(".initialsteps").removeClass('active');
  } else if (currentTab == 1) {
    validateOTP(n, switchTab);
    //switchTab(n);
    //$(".initialsteps").removeClass('active');
  } else if (currentTab == 2) {
    // hideError()
    // var total_systems = 0;
    // jQuery( ".system_qty-input" ).each(function() {
    //   var sysqty = this.value;
    //   total_systems +=parseInt(sysqty);
    // });
    // if (total_systems == 0){
    //   showError("Please select at least one system.")
    //   return false;
    // }
    // if (total_systems <= allowed_systems){
    //   generate_paypalform(payment_token);
    //   cart_summary();
    //   switchTab(n);
    // }else{
    //   showError("Maximum of " + allowed_systems + " systems is allowed per subscription.")
    // }
    // $(".initialsteps").removeClass('active');
  }
}

function resetTab() {
  if (confirm("Are you sure you want to go to pervious step?")) {
    var x = document.getElementsByClassName("steps");
    x[currentTab].style.display = "none";
    currentTab = 0;
    showTab(currentTab);
    $("#otp_code").val("");
  }
}

function previousTab() {
  if (confirm("Are you sure you want to go to pervious step?")) {
    var x = document.getElementsByClassName("steps");
    x[currentTab].style.display = "none";
    currentTab--;
    showTab(currentTab);
    addSubactive();
  }
}

function switchTab(n, form_status = true) {
  var x = document.getElementsByClassName("steps");
  x[currentTab].style.display = "none";
  // Increase or decrease the current tab by 1:
  currentTab = currentTab + n;
  // if you have reached the end of the form...
  if (currentTab >= x.length) {
    // ... the form gets submitted:
    //*submit otp and display the order information
    //document.getElementById("initialsearch").submit();
    if (form_status == true) {
      $(".subscription_success").addClass("active");
    } else {
      $(".subscription_failure").addClass("active");
    }
    $(".main-form").addClass("submitted");
    return false;
  }
  // Otherwise, display the correct tab:
  showTab(currentTab);
}
function validateForm() {
  // This function deals with validation of the form fields
  var x,
    y,
    i,
    valid = true;
  x = document.getElementsByClassName("steps");
  y = x[currentTab].getElementsByTagName("input");
  // A loop that checks every input field in the current tab:
  for (i = 0; i < y.length; i++) {
    // If a field is empty...
    if (y[i].value == "") {
      // add an "invalid" class to the field:
      y[i].className += " invalid";
      // and set the current valid status to false
      valid = false;
    }
  }
  // If the valid status is true, mark the step as finished and valid:
  if (valid) {
    document.getElementsByClassName("steps")[currentTab].className += " finish";
  }
  return valid; // return the valid status
}

function fixStepIndicator(n) {
  // This function removes the "active" class of all steps...
  var i,
    x = document.getElementsByClassName("steps");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  //... and adds the "active" class on the current step:
  x[n].className += " active";
  addSubactive();
}
function clickNext(e) {
  e.preventDefault();
  nextPrev(1);
  addSubactive();
}
function clickBack() {
  resetTab();
  addSubactive();
}
/* ==========================
OTP 
============================*/
function sendusertoOTP(n, callBack) {
  email = $("#email").val().trim();
  phone = $("#phone").val().trim();

  $.ajax({
    type: "POST",
    url: aircon_url + "/api/braintree/sendotp",
    data: { email, phone, utm_params, ua_details },
    success: function (data, status, xhr) {
      if (data.status == true) {
        hideError(message);
        otp_hash = data.data.otp_token;
        $(".phonenum").text(getMaskedNumber(phone));
        callBack(n);
        resendTimer();
        //$("#show_email").val(email)
      } else {
        var message = "";
        if (data.errors.email) {
          showValidationError($("#email"), data.errors.email.toString());
        }
        if (data.errors.phone) {
          showValidationError($("#phone"), data.errors.phone.toString());
        }
        //showError(message)
      }
    },
    beforeSend: function (xhr, settings) {
      xhr.setRequestHeader("Authorization", "Bearer " + tokenString);
      $body.addClass("loading");
    }, //set tokenString before send
    complete: function () {
      $body.removeClass("loading");
    },
  });
}
function initialVideo(){
  var $window = jQuery(window);
  let vid = document.getElementById("videomb"); 
  let vidpc = document.getElementById("videopc"); 
        if ($window.width() < 768) {
          document.getElementById("videomb").autoplay = true;
          vid.play();
        }
        else {
          document.getElementById("videopc").autoplay = true;
          vidpc.play();
        }
}
function stickyRed(){
  $(".red-bar").appendTo("#shopify-section-header");
}
function stickyHide(){
  $(".red-bar").css("display", "none");
}

function validateOTP(n, callBack) {
  otp_code = $("#otp_code").val().trim();
  if (!otp_code || !otp_hash) {
    return false;
  }
  $.ajax({
    type: "POST",
    url: aircon_url + "/api/braintree/validateotp",
    data: { otp_hash, otp_code, email },
    success: function (data, status, xhr) {
      if (data.status == true) {
        payment_token = data.data.payment_token;
        $(".initialsteps").removeClass("active");
        generate_paypalform(payment_token);
        cart_summary();
        //initialVideo();
        stickyRed();
        callBack(n);
      } else {
        if (data.errors) {
          showValidationError($("#otp_code"), data.errors.toString());
        }
        stickyHide();
      }
    },
    beforeSend: function (xhr, settings) {
      xhr.setRequestHeader("Authorization", "Bearer " + tokenString);
      $body.addClass("loading");
    }, //set tokenString before send
    complete: function () {
      $body.removeClass("loading");
    },
  });
}

function generate_paypalform(payment_token) {
  if (!payment_token) {
    return false;
  }

  braintree.dropin
    .create({
      authorization: payment_token,
      selector: "#dropin-container",
      dataCollector: true,
    })
    .then(function (instance) {
      button.addEventListener("click", function () {
        hideError();
        let system_1 = parseInt($("#sys1-qty").val());
        //let system_2 = parseInt($("#sys2-qty").val());
        //let system_3 = parseInt($("#sys3-qty").val());
        //let system_4 = parseInt($("#sys4-qty").val());
        var total_qty = system_1;
        if (total_qty < 1) {
          showError("Please select aircon units.");
          return false;
        } else if (total_qty > allowed_units) {
          showError(
            "Maximum of " +
              allowed_units +
              " units is allowed per subscription."
          );
          return false;
        }
        var pos_invoice = jQuery("#invoiceNum").val();
        if (pos_invoice == ''){
          showValidationError(jQuery("#invoiceNum"), 'Please enter Retail POS invoice number.');
          return false;  
        }else{
          removeValidationError(jQuery("#invoiceNum"));
        }
        instance.requestPaymentMethod(function (err, payload) {
          checkout(
            { system_1 },
            payload,
            instance
          );
        });
      });
    });
}

function checkout(systems, payload, instance) {
  console.log("====================================");
  console.log("payload", payload);
  console.log("====================================");
  if (!payload) {
    return false;
  }
  sub_pay_type = pay_type;
  if (pay_type == "yearly") {
    // set yearly
    upfront_years = 1;
    sub_pay_type = "upfront";
  }
  var staffname = jQuery("#staffName").val();
  var pos_invoice = jQuery("#invoiceNum").val();
  var ipp_payment_option = jQuery("#ippPaymentOption").val();
  let params = {
    paymentMethodNonce: payload.nonce,
    deviceData: payload.deviceData,
    email,
    phone,
    otp_hash,
    otp_code,
    systems,
    pay_type: sub_pay_type,
    utm_params,
    ua_details,
    staffname,
    retail,
    upfront_years,
    total_price: total_sum,
    pos_invoice,
    ipp_payment_option,
    retail_ipp: 1,
  };
  // const sys = ["system 1", "system 2", "system 3", "system 4"];

  $.ajax({
    type: "POST",
    url: aircon_url + "/api/braintree/checkout",
    data: params,
    beforeSend: function (xhr, settings) {
      xhr.setRequestHeader("Authorization", "Bearer " + tokenString);
      $body.addClass("loading");
    }, //set tokenString before send
    complete: function () {
      $body.removeClass("loading");
    },
  }).done(function (result) {
    console.log(result);
    if (result.status != true) {
      instance.clearSelectedPaymentMethod();
      let error = "<p class='validation error'><strong>Payment failed!</strong> Please try again.</p>";
      $("#payment_error").html(error);
      $("#payment_error").css("visibility", "visible");
      return;
    }
    //return;
    // Tear down the Drop-in UI
    instance.teardown(function (teardownErr) {
      if (teardownErr) {
        console.error("Could not tear down Drop-in UI!");
      } else {
        $("#submit-button").remove();
        if (result.status == true) {
          let myIframe = document.getElementById("myIframe");
          // let endpoint = "https://airtable.com/embed/shr9QItu7foiyHi2B?backgroundColor=green";
          let endpoint =
            "https://airtable.com/embed/shr5Rv8D7sEguIG6t?backgroundColor=green";
          let fullURL =
            endpoint +
            "&prefill_SubscriptionID=" +
            result.data.subscription_id +
            "&hide_SubscriptionID=true&prefill_Email Address=" +
            email +
            "&hide_Email Address=true&prefill_Contact Number=" +
            phone +
            "&hide_Contact Number=true";
          // console.log(fullURL);
          myIframe.src = fullURL;
          $("#subsription_ref_id").html(result.data.subscription_id);
          $(".user-email").text(email);
          switchTab(1);
          /* <!-- Start Prismcare Omnivert snippet -->  */
          window._mktz = window._mktz || [];
          window._mktz.push([
            "_Goal",
            "sale-plans",
            total_sum,
            {
              transaction: "'" + result.data.subscription_id + "'",
              skus: "'" + [pay_type] + "'",
            },
          ]);
          /* <!-- End of Prismcare Omnivert snippet -->  */
          $(".prismcare-extendedform").show();
          stickyHide();
        } else {
          switchTab(1, false);
        }
      }
    });
  });
}

function resendTimer() {
  var html = 'Resend (<span id="countdowntimer">' + timeleft + "</span>)";
  document.getElementById("resend_otp").innerHTML = html;
  var downloadTimer = setInterval(function () {
    timeleft--;
    document.getElementById("countdowntimer").textContent = timeleft;
    if (timeleft <= 0) {
      clearInterval(downloadTimer);
      var html = '<a class href="#" onclick="resendOTP()">Resend</a>';
      document.getElementById("resend_otp").innerHTML = html;
    }
  }, 1000);
}

function resendOTP() {
  $.ajax({
    type: "POST",
    url: aircon_url + "/api/braintree/sendotp",
    data: { email, phone },
    success: function (data, status, xhr) {
      if (data.status == true) {
        hideError();
        otp_hash = data.data.otp_token;
        document.getElementById("resend_otp").innerHTML = "";
        timeleft = 90;
        resendTimer();
      }
    },
    beforeSend: function (xhr, settings) {
      xhr.setRequestHeader("Authorization", "Bearer " + tokenString);
      $body.addClass("loading");
    }, //set tokenString before send
    complete: function () {
      $body.removeClass("loading");
    },
  });
}

function getUTMParams() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  var utm_source = urlParams.get("utm_source");

  // shirt

  var utm_medium = urlParams.get("utm_medium");
  // blue
  var utm_campaign = urlParams.get("utm_campaign");
  var utm_term = urlParams.get("utm_term");
  var utm_content = urlParams.get("utm_content");

  return (utm_params = {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  });
}

function getUADetails() {
  let userAgent = navigator.userAgent;
  let ua = detect.parse(navigator.userAgent);
  // let browserName  = `Browser Name: ${ua.browser.name}`;
  let deviceType = ua.device.type;
  let OS = ua.os.name;

  let browser = (function (agent) {
    switch (true) {
      case agent.indexOf("edge") > -1:
        return "edge";
      case agent.indexOf("edg") > -1:
        return "chromium based edge (dev or canary)";
      case agent.indexOf("opr") > -1 && !!window.opr:
        return "opera";
      case agent.indexOf("chrome") > -1 && !!window.chrome:
        return "chrome";
      case agent.indexOf("trident") > -1:
        return "ie";
      case agent.indexOf("firefox") > -1:
        return "firefox";
      case agent.indexOf("safari") > -1:
        return "safari";
      default:
        return "other";
    }
  })(window.navigator.userAgent.toLowerCase());

  let resolution = window.screen.availHeight + " x " + window.screen.availWidth;

  return (uadetails = { userAgent, deviceType, OS, browser, resolution });
}

function reatilParams() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("retail");
}

function getStaffName() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get("staff_name");
}

function isNumber(char) {
  return /^\d$/.test(char);
}

function getMaskedNumber(number) {
  var endDigits = number.slice(-4);
  return endDigits.padStart(number.length, "*");
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
/* =============
add sub-active class
================*/
function addSubactive() {
  if ($("div#care-subscriptionDetails").hasClass("active")) {
    $("div#care-subscriptionDetails").parent().parent().addClass("sub-active");
  } else {
    $("div#care-subscriptionDetails")
      .parent()
      .parent()
      .removeClass("sub-active");
  }
}
